import React from 'react'
import Form from '@blocks/Form'
import { ReactComponent as PasswordIcon } from '@icons/password.svg'
import { Link, useLocation } from 'react-router-dom'
import useTitle from '@hooks/useTitle'
import Button from '@components/blocks/Button'
import Input from '@components/blocks/Input'
import useAuthTemplate from '@auth/components/template/hooks/useAuthTemplate'
import api from '@api'
import { notify, route } from '@helpers'
import useAuth from '@hooks/useAuth'

export default function ResetPage() {
    const location = useLocation()
    const params = new URLSearchParams(location.search)

    const { refreshUser } = useAuth()

    useTitle("Reset")
    useAuthTemplate({
        footer: <p><span>Return to </span><Link to={route("signin")}>Sign in</Link></p>
    })

    const handleSuccess = (data: ResetResponse) => {
        notify(data.message)
        refreshUser()
    }

    return (
        <Form action={api.reset} handleSuccess={handleSuccess} method="post">
            <Input id="token" name="token" type="hidden" defaultValue={params.get("token") || ""} />
            <Input id="email" name="email" type="hidden" defaultValue={params.get("email") || ""} />
            <Input id="password" height="l" name="password" type="password" placeholder="xxxxxxxx" label="New password" required icon={<PasswordIcon />} />
            <Input id="password_confirmation" height="l" name="password_confirmation" type="password" placeholder="xxxxxxxx" label="Repeat new password" required icon={<PasswordIcon />} />
            <Button element="submit">Change</Button>
        </Form>
    )
}

interface ResetResponse {
    message: string
}